/* Explicit form actions. Links keep their native destination if the vendor fails;
   the announcement button stays on-page and offers retry plus a paid-kit link. */
(function () {
  'use strict';
  if (window.__fizzyKlaviyoOpen) return;
  window.__fizzyKlaviyoOpen = true;

  var OPEN_WAIT_MS = 4500;
  var pending = new Map();
  var lastTrigger = null;
  var lastClosed = new Map();

  function formVisible(id) {
    var el = document.querySelector('[data-testid="klaviyo-form-' + id + '"], [role="dialog"][aria-label="POPUP Form"]');
    return !!(el && el.getClientRects().length && window.getComputedStyle(el).display !== 'none');
  }

  function finish(trigger) {
    var attempt = pending.get(trigger);
    if (attempt) window.clearTimeout(attempt.timer);
    if (attempt) window.clearTimeout(attempt.openTimer);
    pending.delete(trigger);
    trigger.removeAttribute('aria-busy');
  }

  function recovery(trigger, id) {
    var box = trigger.nextElementSibling;
    if (!box || !box.hasAttribute('data-klaviyo-recovery')) {
      box = document.createElement('div');
      box.className = 'fz-klaviyo-recovery';
      box.setAttribute('data-klaviyo-recovery', id);
      box.setAttribute('role', 'status');
      var message = document.createElement('p');
      message.textContent = 'Email signup couldn’t open.';
      box.appendChild(message);
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.textContent = 'Try again';
      retry.addEventListener('click', function () { open(trigger, id); });
      box.appendChild(retry);
      var fallback = trigger.getAttribute('data-klaviyo-fallback');
      if (fallback) {
        var link = document.createElement('a');
        link.href = fallback;
        link.textContent = 'Buy the kit for $19.99 with free shipping';
        box.appendChild(link);
      }
      trigger.insertAdjacentElement('afterend', box);
    }
    box.hidden = false;
  }

  function open(trigger, id) {
    if (pending.has(trigger)) return;
    lastTrigger = trigger;
    var box = trigger.nextElementSibling;
    if (box && box.hasAttribute('data-klaviyo-recovery')) box.hidden = true;
    trigger.setAttribute('aria-busy', 'true');
    var href = trigger.tagName === 'A' ? trigger.getAttribute('href') : '';
    function failed() {
      finish(trigger);
      if (!trigger.isConnected || formVisible(id)) return;
      if (href) window.location.href = href;
      else recovery(trigger, id);
    }
    pending.set(trigger, { id: String(id), timer: window.setTimeout(failed, OPEN_WAIT_MS) });
    function requestOpen() {
      try {
        // Queue while vendor JS loads. Let its 350 ms close animation finish before reopening.
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', id]);
      } catch (error) {
        failed();
      }
    }
    var reopenDelay = Math.max(0, 400 - (Date.now() - (lastClosed.get(String(id)) || 0)));
    if (reopenDelay) pending.get(trigger).openTimer = window.setTimeout(requestOpen, reopenDelay);
    else requestOpen();
  }

  // The vendor's close event can arrive after its exit animation begins.
  document.addEventListener('click', function (event) {
    if (lastTrigger && event.target.closest && event.target.closest('.klaviyo-close-form')) {
      lastClosed.set(String(lastTrigger.getAttribute('data-klaviyo-form')), Date.now());
    }
  }, true);

  window.addEventListener('klaviyoForms', function (ev) {
    var d = (ev && ev.detail) || {};
    var id = String(d.formId || '');
    if (d.type === 'open') {
      pending.forEach(function (attempt, trigger) {
        if (attempt.id === id) finish(trigger);
      });
      document.querySelectorAll('[data-klaviyo-recovery]').forEach(function (box) {
        if (box.getAttribute('data-klaviyo-recovery') === id) box.hidden = true;
      });
    }
    if (d.type === 'close') lastClosed.set(id, Date.now());
    if (d.type === 'close' && lastTrigger && id === String(lastTrigger.getAttribute('data-klaviyo-form'))) {
      var trigger = lastTrigger;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (trigger.isConnected && !trigger.closest('[inert]')) trigger.focus({ preventScroll: true });
        });
      });
    }
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-klaviyo-form]');
    if (!trigger) return;
    var id = trigger.getAttribute('data-klaviyo-form');
    if (!id || !/^[a-zA-Z0-9]+$/.test(id)) return;
    if (trigger.tagName === 'A' && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    event.preventDefault();
    open(trigger, id);
  }, false);
})();
